// Generated by scripts/build-posts.mjs from content/blog/*.md. Do not edit by hand.
import type { GeneratedPost } from './postTypes';

export const generatedPosts: GeneratedPost[] = [
  {
    "slug": "10-checks-before-a-sigma-migration-cutover",
    "title": "10 checks before approving a Sigma migration cutover",
    "description": "Review acceptance evidence, permissions, delivery, ownership, recovery, and retirement decisions before switching users from Tableau or Power BI to Sigma.",
    "date": "2026-10-20",
    "updated": "2026-10-21",
    "keywords": [
      "Sigma migration cutover checklist",
      "Sigma migration go live",
      "BI migration acceptance"
    ],
    "tags": [
      "sigma",
      "migration",
      "rollout"
    ],
    "category": "Migration cutover",
    "cover": "/images/blog/10-checks-before-a-sigma-migration-cutover/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 5
  },
  {
    "slug": "7-dax-measure-tests-before-migrating-to-sigma",
    "title": "7 DAX measure tests to define before migrating Power BI to Sigma",
    "description": "Define expected behavior for Power BI measures before rebuilding them in Sigma, including totals, filters, distinct counts, dates, blanks, ratios, and relationships.",
    "seoTitle": "7 DAX measure tests before migrating Power BI to Sigma",
    "date": "2026-10-20",
    "updated": "2026-10-21",
    "keywords": [
      "DAX to Sigma migration",
      "Power BI measure migration",
      "validate DAX migration"
    ],
    "tags": [
      "sigma",
      "migration",
      "powerbi"
    ],
    "category": "Calculation acceptance",
    "cover": "/images/blog/7-dax-measure-tests-before-migrating-to-sigma/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 5
  },
  {
    "slug": "7-tableau-interactions-to-review-before-moving-to-sigma",
    "title": "7 Tableau interactions to review before moving to Sigma",
    "description": "Document how people use Tableau before rebuilding their workflows in Sigma, from filter scope and parameters to actions, tooltips, navigation, and exports.",
    "date": "2026-10-20",
    "updated": "2026-10-21",
    "keywords": [
      "Tableau to Sigma interactions",
      "Tableau dashboard migration checklist",
      "Tableau migration requirements"
    ],
    "tags": [
      "sigma",
      "migration",
      "tableau"
    ],
    "category": "Tableau workflow review",
    "cover": "/images/blog/7-tableau-interactions-to-review-before-moving-to-sigma/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 6
  },
  {
    "slug": "8-tests-for-choosing-a-sigma-migration-pilot",
    "title": "8 tests for choosing a useful Sigma migration pilot",
    "description": "Choose a Power BI or Tableau migration pilot that tests important calculations, shared dependencies, user workflows, and acceptance without becoming the whole project.",
    "seoDescription": "Choose a Power BI or Tableau migration pilot that tests key calculations, shared dependencies, workflows, and acceptance without becoming the project.",
    "date": "2026-10-20",
    "updated": "2026-10-21",
    "keywords": [
      "Sigma migration pilot",
      "Power BI to Sigma proof of concept",
      "Tableau to Sigma pilot"
    ],
    "tags": [
      "sigma",
      "migration",
      "pilot"
    ],
    "category": "Migration pilot",
    "cover": "/images/blog/8-tests-for-choosing-a-sigma-migration-pilot/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 5
  },
  {
    "slug": "9-questions-to-ask-a-sigma-migration-consultant",
    "title": "9 questions to ask a Sigma migration consultant",
    "description": "Compare Sigma migration consultants by asking about scope, data readiness, calculation review, security, validation, ownership, and handover.",
    "date": "2026-10-20",
    "updated": "2026-10-21",
    "keywords": [
      "Sigma migration consultant",
      "Power BI to Sigma consulting",
      "Tableau to Sigma consulting"
    ],
    "tags": [
      "sigma",
      "migration",
      "buying"
    ],
    "category": "Choosing a consultant",
    "cover": "/images/blog/9-questions-to-ask-a-sigma-migration-consultant/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 5
  },
  {
    "slug": "avoid-double-counting-shopify-amazon-tiktok-orders",
    "title": "How to avoid double-counting Shopify, Amazon and TikTok orders",
    "description": "Separate the sales channel from the fulfillment provider, link mirrored orders, and reconcile revenue before combining Shopify, Amazon and TikTok Shop reports.",
    "seoTitle": "Avoid double-counting Shopify, Amazon and TikTok orders",
    "date": "2026-10-31",
    "updated": "2026-11-04",
    "keywords": [
      "Shopify Amazon TikTok duplicate orders",
      "ecommerce order reconciliation",
      "Amazon MCF reporting",
      "sales channel vs fulfillment"
    ],
    "tags": [
      "ecommerce",
      "analytics",
      "sigma"
    ],
    "category": "Guide",
    "cover": "/images/blog/avoid-double-counting-shopify-amazon-tiktok-orders/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 5
  },
  {
    "slug": "best-consumer-brand-analytics-consultancies",
    "title": "The 10 best consumer brand analytics consultancies in 2026",
    "description": "Ten analytics consultancies for consumer and CPG brands selling DTC, in retail, and wholesale, compared on POS, syndicated data, trade, and planning.",
    "date": "2026-11-04",
    "keywords": [
      "CPG analytics consultancy",
      "consumer brand analytics",
      "retail POS data analytics",
      "SPINS Nielsen data consultant",
      "omnichannel analytics CPG"
    ],
    "tags": [
      "ecommerce",
      "retail",
      "data-modeling"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/best-consumer-brand-analytics-consultancies/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 10
  },
  {
    "slug": "best-ecommerce-data-consultancies",
    "title": "The 10 best ecommerce data consultancies in 2026",
    "description": "Ten data and analytics consultancies for DTC, Shopify, and marketplace brands, compared on warehouse builds, attribution, and margin and retention reporting.",
    "date": "2026-11-04",
    "keywords": [
      "ecommerce data consultancy",
      "Shopify data consultant",
      "DTC analytics agency",
      "ecommerce data warehouse consultant",
      "ecommerce analytics consulting"
    ],
    "tags": [
      "ecommerce",
      "shopify",
      "data-modeling"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/best-ecommerce-data-consultancies/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 10
  },
  {
    "slug": "best-sigma-consulting-firms",
    "title": "The 10 best Sigma consulting firms in 2026",
    "description": "Ten Sigma consulting firms compared on focus, size, HQ, and Sigma partner tier, from an independent consultancy to global firms, with sources.",
    "date": "2026-11-04",
    "keywords": [
      "best Sigma consulting firms",
      "Sigma Computing partners",
      "Sigma consultants",
      "Sigma implementation partner",
      "Sigma migration partner"
    ],
    "tags": [
      "sigma",
      "consulting"
    ],
    "category": "Sigma",
    "cover": "/images/blog/best-sigma-consulting-firms/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 11
  },
  {
    "slug": "best-snowflake-consulting-firms",
    "title": "The 10 best Snowflake consulting firms in 2026",
    "description": "Ten Snowflake consulting firms compared on focus, size, HQ, and Snowflake partner tier, from an independent consultancy to global firms, with sources.",
    "date": "2026-11-04",
    "keywords": [
      "best Snowflake consulting firms",
      "Snowflake consulting partners",
      "Snowflake Elite partners",
      "Snowflake consultants",
      "Snowflake implementation partner"
    ],
    "tags": [
      "snowflake",
      "consulting"
    ],
    "category": "Snowflake",
    "cover": "/images/blog/best-snowflake-consulting-firms/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 11
  },
  {
    "slug": "blended-attributed-incremental-marginal-cac",
    "title": "Blended, attributed, incremental, and marginal CAC: which one guides the next dollar?",
    "description": "Blended CAC describes the whole business, attributed CAC assigns credit, incremental CAC estimates cause, and marginal CAC asks what the next dollar buys.",
    "seoTitle": "Blended, attributed, incremental, and marginal CAC explained",
    "date": "2026-10-30",
    "updated": "2026-11-04",
    "keywords": [
      "blended vs incremental CAC",
      "marginal CAC vs average CAC",
      "attributed CAC",
      "how to calculate incremental CAC",
      "channel saturation"
    ],
    "tags": [
      "ecommerce",
      "marketing",
      "analytics"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/blended-attributed-incremental-marginal-cac/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 6
  },
  {
    "slug": "break-into-data-through-consulting",
    "title": "Breaking into data? Join a consulting firm first (8 I'd look at)",
    "description": "Why a consulting firm is one of the best first jobs in data, the trade-offs versus an internal analyst role, and 8 data consultancies I'd look at joining.",
    "seoTitle": "Breaking into data? Join a consulting firm first",
    "date": "2026-11-04",
    "keywords": [
      "how to break into data analytics",
      "data consulting career",
      "data analytics consulting firms",
      "entry level data consulting jobs",
      "consulting vs in-house data analyst"
    ],
    "tags": [
      "consulting",
      "careers"
    ],
    "category": "Careers",
    "cover": "/images/blog/break-into-data-through-consulting/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 6
  },
  {
    "slug": "bronze-silver-gold-ecommerce-order-example",
    "title": "Bronze, silver, and gold data layers explained with an ecommerce order",
    "description": "Bronze keeps the data as it arrived, silver cleans and matches it, and gold shapes it for business use. Follow one order, a duplicate, and a late refund.",
    "seoTitle": "Bronze, silver, and gold layers with an ecommerce order",
    "date": "2026-10-30",
    "keywords": [
      "bronze silver gold ecommerce",
      "medallion architecture example",
      "bronze silver gold data layers",
      "data warehouse layers explained"
    ],
    "tags": [
      "ecommerce",
      "data-modeling",
      "dbt"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/bronze-silver-gold-ecommerce-order-example/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 5
  },
  {
    "slug": "choose-a-data-platform-beyond-features",
    "title": "How do you choose a data platform beyond the feature list?",
    "description": "Compare data platforms on support, customer experience, cost controls, and ecosystem, not only features. What to check, how to test each one, and a checklist.",
    "date": "2026-11-04",
    "keywords": [
      "how to choose a data platform",
      "data platform evaluation",
      "data warehouse evaluation criteria",
      "Snowflake support",
      "data platform checklist"
    ],
    "tags": [
      "snowflake",
      "data-platform"
    ],
    "category": "Snowflake",
    "cover": "/images/blog/choose-a-data-platform-beyond-features/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 8
  },
  {
    "slug": "common-ecommerce-data-sources-warehouse",
    "title": "9 ecommerce data sources worth connecting to a warehouse",
    "description": "Nine source types to consider for an ecommerce warehouse, with the question each answers, its useful key, a caveat, and when it's worth connecting.",
    "date": "2026-10-30",
    "keywords": [
      "ecommerce data sources",
      "ecommerce data warehouse sources",
      "what data to connect to a warehouse",
      "Shopify Amazon Klaviyo data warehouse"
    ],
    "tags": [
      "ecommerce",
      "data-modeling",
      "apis"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/common-ecommerce-data-sources-warehouse/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 4
  },
  {
    "slug": "connect-chatgpt-to-snowflake",
    "title": "How to Connect ChatGPT to Snowflake (Step-by-Step)",
    "description": "Connect ChatGPT to Snowflake with MCP and OAuth. Find the account URL, client credentials, role, and default warehouse, then test access.",
    "date": "2026-09-04",
    "keywords": [
      "connect ChatGPT to Snowflake",
      "ChatGPT Snowflake connector",
      "Snowflake MCP server ChatGPT",
      "ChatGPT Developer Mode Snowflake",
      "Snowflake OAuth MCP"
    ],
    "tags": [
      "snowflake",
      "chatgpt",
      "mcp"
    ],
    "category": "Snowflake",
    "cover": "/images/blog/connect-chatgpt-to-snowflake/cover.jpg",
    "coverWidth": 1672,
    "coverHeight": 941,
    "readingMinutes": 8
  },
  {
    "slug": "connect-claude-to-snowflake",
    "title": "How to Connect Claude to Snowflake (Step-by-Step)",
    "description": "Connect Claude to Snowflake with MCP and OAuth. Find the account URL, client credentials, role, and default warehouse, then fix failed queries.",
    "date": "2026-09-04",
    "keywords": [
      "connect Claude to Snowflake",
      "Claude Snowflake connector",
      "Snowflake MCP server Claude",
      "Claude Team Snowflake connector",
      "Snowflake OAuth MCP"
    ],
    "tags": [
      "snowflake",
      "claude",
      "mcp"
    ],
    "category": "Snowflake",
    "cover": "/images/blog/connect-claude-to-snowflake/cover-v2.jpg",
    "coverWidth": 1600,
    "coverHeight": 900,
    "readingMinutes": 10
  },
  {
    "slug": "connect-excel-to-snowflake-with-private-key-mac",
    "title": "Connect Excel for Mac to Snowflake with a private key",
    "description": "Set up Snowflake key-pair authentication for Excel on macOS, configure a User DSN, and troubleshoot driver loading, key-file access, and refresh errors.",
    "date": "2026-11-02",
    "keywords": [
      "Excel Mac Snowflake",
      "Snowflake ODBC Mac private key",
      "Excel macOS key pair authentication",
      "Microsoft Query Snowflake",
      "Snowflake Mac ODBC driver"
    ],
    "tags": [
      "snowflake",
      "excel",
      "setup"
    ],
    "category": "Snowflake",
    "cover": "/images/blog/connect-excel-to-snowflake-with-private-key-mac/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 8
  },
  {
    "slug": "connect-excel-to-snowflake-with-private-key",
    "title": "Connect Excel to Snowflake with a private key on Windows",
    "description": "Connect Windows Excel to Snowflake with key-pair authentication. Set up OpenSSL, add missing ODBC private-key fields, and fix PRIV_KEY_FILE errors.",
    "date": "2026-11-02",
    "keywords": [
      "Excel Snowflake private key",
      "Snowflake ODBC key pair authentication",
      "Excel Snowflake connection",
      "SNOWFLAKE_JWT",
      "Windows Excel ODBC"
    ],
    "tags": [
      "snowflake",
      "excel",
      "setup"
    ],
    "category": "Snowflake",
    "cover": "/images/blog/connect-excel-to-snowflake-with-private-key/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 12
  },
  {
    "slug": "consumer-brand-retention-dashboard-in-sigma",
    "title": "A customer retention dashboard in Sigma, in five reports",
    "description": "A public Sigma workbook for a consumer brand that answers five retention questions, from who is buying to who came back after a break. Built on synthetic data you can explore.",
    "seoDescription": "A public Sigma workbook that answers five retention questions for a consumer brand, from who is buying to who came back. Built on synthetic data.",
    "date": "2026-11-03",
    "keywords": [
      "customer retention dashboard Sigma",
      "ecommerce retention dashboard",
      "90-day repeat rate",
      "cohort retention Sigma",
      "reactivated customers report",
      "Sigma public workbook"
    ],
    "tags": [
      "sigma",
      "ecommerce",
      "retention"
    ],
    "category": "Sigma how-to",
    "cover": "/images/blog/consumer-brand-retention-dashboard-in-sigma/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 5
  },
  {
    "slug": "contribution-margin-ltv-by-acquisition-channel",
    "title": "How do you calculate contribution margin LTV by acquisition channel?",
    "description": "Group customers by first order month and channel, compare cohorts at the same age, and subtract variable costs and CAC before you move spend.",
    "seoTitle": "How to calculate contribution margin LTV by channel",
    "date": "2026-10-30",
    "keywords": [
      "contribution margin LTV",
      "LTV by acquisition channel",
      "cohort LTV ecommerce",
      "customer lifetime value by channel",
      "CAC payback by channel"
    ],
    "tags": [
      "ecommerce",
      "shopify",
      "analytics"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/contribution-margin-ltv-by-acquisition-channel/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 6
  },
  {
    "slug": "daily-ecommerce-kpis-by-channel",
    "title": "Daily ecommerce KPIs by channel: what belongs in the morning scorecard?",
    "description": "A daily ecommerce scorecard needs net sales, orders, new customers, ad spend, refunds, and data freshness by channel, each with a written denominator and cutoff.",
    "seoTitle": "Daily ecommerce KPIs by channel for a morning scorecard",
    "date": "2026-10-30",
    "keywords": [
      "daily ecommerce dashboard",
      "ecommerce KPIs by channel",
      "daily sales report",
      "ecommerce morning scorecard",
      "DTC marketplace wholesale reporting"
    ],
    "tags": [
      "ecommerce",
      "analytics",
      "reporting"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/daily-ecommerce-kpis-by-channel/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 7
  },
  {
    "slug": "ecommerce-data-ingestion-tools",
    "title": "How to choose a data ingestion tool for ecommerce: Fivetran, Airbyte, Daton, Funnel, and custom code",
    "description": "Compare Fivetran, Airbyte, Daton, Funnel, Portable, Stitch, and custom code for Shopify, Amazon, TikTok Shop, Klaviyo, and ads, and pick one per source.",
    "seoTitle": "Ecommerce data ingestion tools: Fivetran, Airbyte, Daton",
    "date": "2026-11-04",
    "keywords": [
      "ecommerce data ingestion tools",
      "Fivetran vs Airbyte for Shopify",
      "Daton vs Fivetran",
      "Funnel vs Airbyte",
      "ecommerce ELT tools",
      "Klaviyo data pipeline"
    ],
    "tags": [
      "ecommerce",
      "shopify",
      "data-modeling"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/ecommerce-data-ingestion-tools/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 13
  },
  {
    "slug": "ecommerce-data-stack-tools-mapped",
    "title": "The ecommerce data stack, mapped: 57 tools from storefront to dashboard",
    "description": "A map of the ecommerce data stack in 9 categories, from Shopify and Amazon to connectors, warehouses, packaged analytics, and BI, with what each tool does.",
    "seoTitle": "The ecommerce data stack, mapped: 57 tools",
    "date": "2026-11-03",
    "keywords": [
      "ecommerce data stack",
      "ecommerce analytics tools",
      "Shopify data stack",
      "DTC data stack",
      "ecommerce reporting tools"
    ],
    "tags": [
      "ecommerce",
      "shopify",
      "data-modeling"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/ecommerce-data-stack-tools-mapped/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 7
  },
  {
    "slug": "ecommerce-data-stack-white-paper",
    "title": "The ecommerce data stack: how to choose tools and plan the build (free white paper)",
    "description": "A free white paper for DTC and omnichannel brands on choosing ecommerce data stack tools by stage, plus a five-phase plan with owners and checks.",
    "seoTitle": "The ecommerce data stack: choose tools and plan the build",
    "date": "2026-11-04",
    "keywords": [
      "ecommerce data stack",
      "ecommerce data stack white paper",
      "DTC data stack",
      "Shopify data warehouse plan",
      "ecommerce analytics implementation plan"
    ],
    "tags": [
      "ecommerce",
      "data-modeling",
      "shopify"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/ecommerce-data-stack-white-paper/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 6
  },
  {
    "slug": "ecommerce-profit-dashboard-checklist",
    "title": "20 checks before you trust an ecommerce profit dashboard",
    "description": "Twenty plain checks for Shopify, Amazon and TikTok Shop profit dashboards, covering fees, late costs, dates, time zones, channel allocation and CAC definitions.",
    "date": "2026-11-04",
    "keywords": [
      "ecommerce profit dashboard checklist",
      "ecommerce dashboard accuracy",
      "validate ecommerce reporting",
      "Shopify Amazon TikTok profit report",
      "ecommerce data quality checks"
    ],
    "tags": [
      "ecommerce",
      "analytics",
      "reporting"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/ecommerce-profit-dashboard-checklist/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 5
  },
  {
    "slug": "ecommerce-semantic-layer",
    "title": "Ecommerce semantic layer: a metric dictionary for gross sales to LTV",
    "description": "Definitions for gross sales, net sales, net revenue, contribution margin, CAC, repeat rate, and LTV, with grain, date, sources, owner, and a free template.",
    "seoTitle": "Ecommerce semantic layer: a metric dictionary up to LTV",
    "date": "2026-11-04",
    "keywords": [
      "ecommerce semantic layer",
      "ecommerce metric dictionary",
      "ecommerce KPI definitions",
      "net sales vs net revenue",
      "contribution margin definition ecommerce",
      "metric dictionary template"
    ],
    "tags": [
      "ecommerce",
      "data-modeling",
      "shopify"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/ecommerce-semantic-layer/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 9
  },
  {
    "slug": "excel-to-sigma-functions-cheat-sheet",
    "title": "Excel to Sigma functions: a practical formula cheat sheet",
    "description": "Translate Excel formulas into Sigma with step-by-step setup, lookup diagnostics, monthly date filters, conditional totals and downloadable validation examples.",
    "date": "2026-10-31",
    "updated": "2026-11-01",
    "keywords": [
      "Excel to Sigma functions",
      "Sigma formula cheat sheet",
      "SUMIFS in Sigma",
      "XLOOKUP in Sigma",
      "Excel vs Sigma formulas"
    ],
    "tags": [
      "sigma",
      "excel",
      "formulas"
    ],
    "category": "Sigma how-to",
    "cover": "/images/blog/excel-to-sigma-functions-cheat-sheet/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 9
  },
  {
    "slug": "give-analysts-safe-ai-access-to-snowflake",
    "title": "Financial analysts are becoming data engineers: how to give them safe AI access to Snowflake",
    "description": "How to let analysts use Claude on Snowflake safely, with a read-only role, approved tables, resource monitors, query timeouts, and changes reviewed in git.",
    "seoTitle": "How to give analysts safe AI access to Snowflake",
    "date": "2026-11-04",
    "keywords": [
      "AI access to Snowflake",
      "Claude Snowflake analyst",
      "Snowflake read-only role for AI",
      "analysts using AI for data engineering",
      "safe AI data access"
    ],
    "tags": [
      "snowflake",
      "ai",
      "claude",
      "dbt"
    ],
    "category": "Snowflake",
    "cover": "/images/blog/give-analysts-safe-ai-access-to-snowflake/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 8
  },
  {
    "slug": "how-i-set-up-a-new-snowflake-account",
    "title": "Snowflake Initial Setup: Roles, Warehouses and Grants",
    "description": "The roles, warehouses, resource monitors, databases, schemas, grants, and key-pair service user I create before the first data load reaches a new Snowflake account.",
    "date": "2026-09-02",
    "keywords": [
      "snowflake initial setup script",
      "snowflake account setup best practices",
      "snowflake roles warehouses resource monitors",
      "snowflake future grants",
      "snowflake service user key pair"
    ],
    "tags": [
      "snowflake",
      "setup",
      "cost"
    ],
    "category": "Snowflake",
    "cover": "/images/blog/how-i-set-up-a-new-snowflake-account/cover-v2.jpg",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 6
  },
  {
    "slug": "how-long-does-a-sigma-migration-take",
    "title": "How long does a Power BI or Tableau migration to Sigma take?",
    "description": "Build a realistic Sigma migration timeline around data readiness, shared models, conversion, validation, business review, and cutover dependencies.",
    "date": "2026-10-20",
    "updated": "2026-10-21",
    "keywords": [
      "how long does a Sigma migration take",
      "Power BI to Sigma migration timeline",
      "Tableau to Sigma migration timeline"
    ],
    "tags": [
      "sigma",
      "migration",
      "planning"
    ],
    "category": "Migration planning",
    "cover": "/images/blog/how-long-does-a-sigma-migration-take/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 5
  },
  {
    "slug": "how-to-build-a-combo-chart-in-sigma",
    "title": "How to Build a Combo Chart in Sigma",
    "description": "Build a Sigma combo chart with revenue bars, a margin line, and a second axis. Follow the editor steps and handle partial months correctly.",
    "date": "2026-09-02",
    "keywords": [
      "Sigma combo chart",
      "Sigma bar and line chart",
      "Sigma dual axis",
      "Sigma right y-axis",
      "Sigma Computing chart tutorial"
    ],
    "tags": [
      "sigma",
      "charts",
      "sigma-as-code"
    ],
    "category": "Sigma how-to",
    "cover": "/images/blog/how-to-build-a-combo-chart-in-sigma/cover-v2.jpg",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 3
  },
  {
    "slug": "how-to-combine-shopify-klaviyo-recharge-data",
    "title": "How do you combine Shopify, Klaviyo, and Recharge data into one customer view?",
    "description": "Join Shopify, Klaviyo, and Recharge on the right keys, count each renewal once, and keep skips as events so one customer timeline holds up.",
    "seoTitle": "Shopify, Klaviyo, and Recharge data in one customer view",
    "date": "2026-10-30",
    "keywords": [
      "combine Shopify Klaviyo Recharge data",
      "Shopify Recharge data warehouse",
      "customer lifecycle data model",
      "Recharge skipped charges reporting",
      "Klaviyo Shopify customer view"
    ],
    "tags": [
      "shopify",
      "ecommerce",
      "data-modeling"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/how-to-combine-shopify-klaviyo-recharge-data/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 6
  },
  {
    "slug": "how-to-learn-sigma-computing",
    "title": "How I learned Sigma and got certified in 4 weeks, and why I'd pick it over Tableau and Power BI",
    "description": "The four resources I used to learn Sigma Computing in 4 weeks, a week-by-week plan to follow, and five reasons I'd pick Sigma over Tableau and Power BI.",
    "seoTitle": "How to learn Sigma Computing in 4 weeks: my plan",
    "seoDescription": "The 4 resources I used to learn Sigma Computing and get certified in 4 weeks, a week-by-week plan, and why I'd pick Sigma over Tableau and Power BI.",
    "date": "2026-11-04",
    "keywords": [
      "how to learn Sigma Computing",
      "Sigma certification",
      "Sigma vs Tableau",
      "Sigma vs Power BI",
      "Sigma Computing training",
      "Sigma Fundamentals DataCamp"
    ],
    "tags": [
      "sigma",
      "tableau",
      "powerbi"
    ],
    "category": "Sigma",
    "cover": "/images/blog/how-to-learn-sigma-computing/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 10
  },
  {
    "slug": "how-to-merge-cells-in-a-sigma-table",
    "title": "How to Merge Cells in Sigma Using Table Grouping",
    "description": "Show a label once across rows in Sigma using table grouping. Follow the steps, compare pivot tables, and understand the limits of merging cells.",
    "date": "2026-09-02",
    "keywords": [
      "Sigma merge cells",
      "Sigma grouped table",
      "Sigma pivot table row labels",
      "Sigma table formatting",
      "Sigma Computing table tutorial"
    ],
    "tags": [
      "sigma",
      "tables",
      "formatting",
      "sigma-as-code"
    ],
    "category": "Sigma how-to",
    "cover": "/images/blog/how-to-merge-cells-in-a-sigma-table/cover-v2.jpg",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 3
  },
  {
    "slug": "how-to-plan-a-power-bi-to-sigma-migration",
    "title": "How to plan a Power BI to Sigma migration",
    "description": "Scope a Power BI to Sigma migration around shared models, DAX definitions, data readiness, a representative pilot, and acceptance checks.",
    "date": "2026-10-20",
    "updated": "2026-10-21",
    "keywords": [
      "Power BI to Sigma migration",
      "migrate Power BI to Sigma",
      "Sigma migration assessment"
    ],
    "tags": [
      "powerbi",
      "sigma",
      "migration"
    ],
    "category": "Migration planning",
    "cover": "/images/blog/how-to-plan-a-power-bi-to-sigma-migration/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 5
  },
  {
    "slug": "how-to-plan-a-tableau-to-sigma-migration",
    "title": "How to plan a Tableau to Sigma migration",
    "description": "Plan a Tableau to Sigma migration around workbook dependencies, calculation behavior, source data, a representative pilot, and a controlled rollout.",
    "date": "2026-10-20",
    "updated": "2026-10-21",
    "keywords": [
      "Tableau to Sigma migration",
      "migrate Tableau to Sigma",
      "Tableau migration assessment"
    ],
    "tags": [
      "tableau",
      "sigma",
      "migration"
    ],
    "category": "Migration planning",
    "cover": "/images/blog/how-to-plan-a-tableau-to-sigma-migration/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 6
  },
  {
    "slug": "how-to-track-customers-across-platforms",
    "title": "How do you track a customer across Shopify, Klaviyo, Recharge, and your ad platforms?",
    "description": "Build one customer view by stitching IDs into an identity table and loading every touchpoint into one events table. With a schema, SQL, and a working demo.",
    "seoTitle": "Track customers across Shopify, Klaviyo, Recharge, and ads",
    "date": "2026-11-04",
    "keywords": [
      "unified customer view",
      "track customers across platforms",
      "Shopify Klaviyo Recharge data",
      "customer 360 ecommerce",
      "identity resolution ecommerce"
    ],
    "tags": [
      "ecommerce",
      "shopify",
      "data-modeling"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/how-to-track-customers-across-platforms/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 6
  },
  {
    "slug": "how-to-validate-a-sigma-migration",
    "title": "How to validate a Tableau or Power BI migration to Sigma",
    "description": "Validate a Sigma migration with matched data cutoffs, source-to-target comparisons, filter tests, access checks, and explicit business acceptance.",
    "date": "2026-10-20",
    "updated": "2026-10-21",
    "keywords": [
      "Sigma migration validation",
      "Power BI to Sigma validation",
      "Tableau to Sigma validation"
    ],
    "tags": [
      "sigma",
      "migration",
      "validation"
    ],
    "category": "Migration validation",
    "cover": "/images/blog/how-to-validate-a-sigma-migration/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 5
  },
  {
    "slug": "incremental-klaviyo-loads-watermarks-rate-limits",
    "title": "Incremental Klaviyo loads: watermarks, rate limits, and why profile updated misleads you",
    "description": "How an incremental Klaviyo to Snowflake load avoids skipped and duplicate rows, with code for watermarks, timestamp ties, lost cursors, 429 retries and profile updates.",
    "seoTitle": "Incremental Klaviyo loads: watermarks and rate limits",
    "seoDescription": "How an incremental Klaviyo to Snowflake load avoids skipped and duplicate rows, with code for watermarks, timestamp ties, and 429 retries.",
    "date": "2026-11-04",
    "keywords": [
      "Klaviyo incremental sync",
      "Klaviyo API rate limits",
      "Klaviyo profile updated",
      "incremental load watermark",
      "Klaviyo to Snowflake"
    ],
    "tags": [
      "snowflake",
      "ecommerce",
      "klaviyo"
    ],
    "category": "Snowflake",
    "cover": "/images/blog/incremental-klaviyo-loads-watermarks-rate-limits/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 9
  },
  {
    "slug": "klaviyo-dbt-models-snowflake",
    "title": "Klaviyo dbt models for Snowflake: profiles, engagement, and a mailable list",
    "description": "Open-source dbt models that turn raw Klaviyo data in Snowflake into a profiles dim, an events fact, 30/90/365-day engagement flags and a mailable list.",
    "seoTitle": "Klaviyo dbt models for Snowflake: profiles and engagement",
    "date": "2026-11-04",
    "keywords": [
      "Klaviyo dbt models",
      "Klaviyo dbt package",
      "Klaviyo Snowflake data model",
      "Klaviyo engagement segments SQL",
      "Klaviyo Shopify customer join"
    ],
    "tags": [
      "dbt",
      "klaviyo",
      "snowflake",
      "ecommerce"
    ],
    "category": "dbt",
    "cover": "/images/blog/klaviyo-dbt-models-snowflake/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 12
  },
  {
    "slug": "map-skus-shopify-amazon-tiktok-margin",
    "title": "Map SKUs across Shopify, Amazon and TikTok without breaking margin",
    "description": "Build a product crosswalk with source IDs, dated mappings and explicit bundle quantities. Catch duplicate joins and missing costs before calculating product margin.",
    "seoTitle": "Map SKUs across Shopify, Amazon, and TikTok for margin",
    "date": "2026-10-31",
    "keywords": [
      "Shopify Amazon TikTok SKU mapping",
      "ecommerce product mapping",
      "SKU cost mapping",
      "product margin reconciliation"
    ],
    "tags": [
      "ecommerce",
      "analytics",
      "sigma"
    ],
    "category": "Guide",
    "cover": "/images/blog/map-skus-shopify-amazon-tiktok-margin/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 4
  },
  {
    "slug": "modern-data-stack-tools-mapped",
    "title": "The data stack, mapped: 61 tools by the job they do",
    "description": "A map of the modern data stack in 11 categories, from ingestion and warehouses to semantic layers, BI, and AI, with what each tool does and how to choose.",
    "date": "2026-11-03",
    "updated": "2026-11-04",
    "keywords": [
      "modern data stack",
      "data stack tools",
      "data stack map",
      "data engineering tools by category",
      "analytics stack"
    ],
    "tags": [
      "snowflake",
      "data-modeling",
      "bi"
    ],
    "category": "Guide",
    "cover": "/images/blog/modern-data-stack-tools-mapped/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 8
  },
  {
    "slug": "move-from-on-prem-and-legacy-bi-to-snowflake-sigma",
    "title": "How do you move from an on-prem database and legacy BI to Snowflake and Sigma?",
    "description": "A five-phase plan for moving an on-prem database and Tableau or Power BI to Snowflake and Sigma: inventory, load, convert, rebuild, then validate and cut over.",
    "seoTitle": "Move from on-prem and legacy BI to Snowflake and Sigma",
    "date": "2026-11-04",
    "keywords": [
      "migrate on-prem database to Snowflake",
      "legacy BI migration",
      "SQL Server to Snowflake migration",
      "Tableau to Sigma migration",
      "Snowflake migration plan"
    ],
    "tags": [
      "snowflake",
      "sigma",
      "migration"
    ],
    "category": "Snowflake",
    "cover": "/images/blog/move-from-on-prem-and-legacy-bi-to-snowflake-sigma/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 7
  },
  {
    "slug": "open-source-klaviyo-snowflake-sync",
    "title": "An open-source Klaviyo to Snowflake sync: how it works and when to use it",
    "description": "An MIT-licensed sync that loads Klaviyo profiles and events into Snowflake incrementally. What it loads, how it works, setup steps, and when to use a connector.",
    "seoTitle": "Open-source Klaviyo to Snowflake sync: how it works",
    "date": "2026-11-04",
    "keywords": [
      "Klaviyo to Snowflake",
      "Klaviyo Snowflake integration",
      "open source Klaviyo connector",
      "Klaviyo incremental sync",
      "Klaviyo data pipeline"
    ],
    "tags": [
      "ecommerce",
      "snowflake",
      "klaviyo"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/open-source-klaviyo-snowflake-sync/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 10
  },
  {
    "slug": "power-bi-dax-to-sigma-formulas-cheat-sheet",
    "title": "Power BI DAX to Sigma formulas: a practical cheat sheet",
    "description": "Rebuild DAX calculations in Sigma with step-by-step setup, CALCULATE filter patterns, blank-count rules and ratio tests using downloadable sample data.",
    "date": "2026-11-01",
    "updated": "2026-11-01",
    "keywords": [
      "DAX to Sigma",
      "Power BI to Sigma formulas",
      "Sigma CALCULATE equivalent",
      "Sigma DISTINCTCOUNT"
    ],
    "tags": [
      "powerbi",
      "sigma",
      "formulas"
    ],
    "category": "Sigma how-to",
    "cover": "/images/blog/power-bi-dax-to-sigma-formulas-cheat-sheet/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 8
  },
  {
    "slug": "power-bi-tableau-to-sigma-migration-cost",
    "title": "What determines the cost of a Power BI or Tableau migration to Sigma?",
    "description": "Understand the work that drives Sigma migration costs, from shared models and data preparation to calculation fixes, validation, and rollout.",
    "seoTitle": "Power BI or Tableau to Sigma migration cost: what drives it",
    "date": "2026-10-20",
    "updated": "2026-10-21",
    "keywords": [
      "Power BI to Sigma migration cost",
      "Tableau to Sigma migration cost",
      "Sigma migration estimate"
    ],
    "tags": [
      "sigma",
      "migration",
      "cost"
    ],
    "category": "Migration planning",
    "cover": "/images/blog/power-bi-tableau-to-sigma-migration-cost/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 5
  },
  {
    "slug": "revenue-goal-calculator-for-webinar-launches",
    "title": "How to work backward from a revenue goal for a webinar launch",
    "description": "A Google Sheets calculator that turns a revenue goal into page visitors, tickets, applicants, and clients, per launch and per webinar. With the formulas and a worked $1M example.",
    "seoTitle": "Work backward from a revenue goal for a webinar launch",
    "seoDescription": "A Google Sheets calculator that turns a revenue goal into visitors, tickets, applicants, and clients per webinar, with formulas and a worked example.",
    "date": "2026-11-03",
    "keywords": [
      "revenue goal calculator",
      "webinar funnel calculator",
      "reverse funnel calculator Google Sheets",
      "high-ticket offer planning",
      "launch planning spreadsheet"
    ],
    "tags": [
      "google-sheets",
      "calculators",
      "revenue-planning"
    ],
    "category": "Guide",
    "cover": "/images/blog/revenue-goal-calculator-for-webinar-launches/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 4
  },
  {
    "slug": "shopify-refund-date-vs-order-date",
    "title": "Shopify refund date vs order date: why monthly sales differ",
    "description": "A refund processed this month can belong to last month's order. Learn how event-date and order-cohort reporting differ and reconcile both without double counting.",
    "date": "2026-10-31",
    "updated": "2026-11-04",
    "keywords": [
      "Shopify refund date vs order date",
      "Shopify monthly sales discrepancy",
      "Shopify sales reversals",
      "ecommerce refund reporting"
    ],
    "tags": [
      "ecommerce",
      "analytics",
      "sigma"
    ],
    "category": "Guide",
    "cover": "/images/blog/shopify-refund-date-vs-order-date/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 5
  },
  {
    "slug": "sigma-experts-to-follow",
    "title": "Sigma experts to follow in 2026: the best builders on Sigma Public",
    "description": "Ten Sigma Computing experts worth following in 2026, with the Sigma Public apps, tutorials, and videos to open first from each builder and educator.",
    "seoTitle": "Sigma experts to follow in 2026: builders on Sigma Public",
    "date": "2026-11-04",
    "keywords": [
      "Sigma experts",
      "Sigma Computing experts",
      "Sigma Public",
      "best Sigma workbooks",
      "Sigma builders to follow",
      "Sigma app examples"
    ],
    "tags": [
      "sigma",
      "community"
    ],
    "category": "Sigma",
    "cover": "/images/blog/sigma-experts-to-follow/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 11
  },
  {
    "slug": "sigma-export-bursting-personalized-pdf-reports",
    "title": "Sigma Export Bursting: how to send personalized PDF reports by region, on a schedule",
    "description": "How to set up Sigma Export Bursting so each person gets a PDF filtered to their region, with your branding, your sender address, and a weekly schedule.",
    "seoTitle": "Sigma Export Bursting: personalized PDF reports on a schedule",
    "date": "2026-11-04",
    "keywords": [
      "Sigma export bursting",
      "Sigma email burst",
      "Sigma scheduled PDF export",
      "Sigma personalized reports",
      "Sigma report bursting"
    ],
    "tags": [
      "sigma",
      "reporting"
    ],
    "category": "Sigma",
    "cover": "/images/blog/sigma-export-bursting-personalized-pdf-reports/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 9
  },
  {
    "slug": "sigma-functions-list",
    "title": "Every Sigma function, explained: the complete list with syntax and examples",
    "description": "All 239 Sigma workbook functions in 13 categories, each with its syntax, a one-line explanation, and a link to Sigma's docs, plus worked examples.",
    "seoTitle": "Sigma functions list: syntax and examples for every function",
    "date": "2026-11-04",
    "keywords": [
      "Sigma functions list",
      "Sigma Computing functions",
      "Sigma formula syntax",
      "Sigma window functions",
      "Sigma Lookup function",
      "Sigma date functions"
    ],
    "tags": [
      "sigma",
      "formulas"
    ],
    "category": "Sigma how-to",
    "cover": "/images/blog/sigma-functions-list/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 33
  },
  {
    "slug": "snowflake-semantic-views-guide",
    "title": "How do you build a semantic layer in Snowflake with semantic views?",
    "description": "A worked CREATE SEMANTIC VIEW example on an orders and customers model, how to query it, how Cortex Analyst uses it, and the limits to plan for.",
    "seoTitle": "Build a semantic layer in Snowflake with semantic views",
    "date": "2026-11-04",
    "keywords": [
      "Snowflake semantic views",
      "CREATE SEMANTIC VIEW",
      "Snowflake semantic layer",
      "Cortex Analyst semantic view",
      "SEMANTIC_VIEW query"
    ],
    "tags": [
      "snowflake",
      "data-modeling",
      "ai"
    ],
    "category": "Snowflake",
    "cover": "/images/blog/snowflake-semantic-views-guide/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 12
  },
  {
    "slug": "snowflake-warehouse-cost-spike-compilation-time",
    "title": "Snowflake Credit Spike? Check Query Compilation Time",
    "description": "Investigate a Snowflake credit spike with a query that compares compilation and execution time. Find the cause and reduce unnecessary warehouse runtime.",
    "date": "2026-09-02",
    "keywords": [
      "Snowflake credits spike",
      "Snowflake compilation_time",
      "Snowflake query_history",
      "Snowflake warehouse cost",
      "Snowflake auto-suspend not working"
    ],
    "tags": [
      "snowflake",
      "cost",
      "sql"
    ],
    "category": "Snowflake",
    "cover": "/images/blog/snowflake-warehouse-cost-spike-compilation-time/cover-v2.jpg",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 5
  },
  {
    "slug": "start-a-data-practice-from-zero",
    "title": "How I'd start a company's data practice from zero in 2026",
    "description": "My 8 steps to start a data practice from zero: Snowflake, Airbyte, dbt layers, a BI tool with an API, SSO, approved tables, AI agents, and cost limits.",
    "date": "2026-11-04",
    "keywords": [
      "how to start a data practice",
      "building a data team from scratch",
      "modern data stack for a startup",
      "first data hire stack",
      "snowflake dbt airbyte setup"
    ],
    "tags": [
      "snowflake",
      "dbt",
      "bi",
      "data-modeling"
    ],
    "category": "Snowflake",
    "cover": "/images/blog/start-a-data-practice-from-zero/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 10
  },
  {
    "slug": "tableau-to-sigma-functions-cheat-sheet",
    "title": "Tableau to Sigma functions and concepts: a practical cheat sheet",
    "description": "Rebuild Tableau calculations in Sigma with worked FIXED denominator, running-total and parameter examples, copyable formulas and filter-validation steps.",
    "seoTitle": "Tableau to Sigma functions and concepts: a cheat sheet",
    "date": "2026-11-01",
    "updated": "2026-11-01",
    "keywords": [
      "Tableau to Sigma functions",
      "Tableau Sigma equivalents",
      "Tableau FIXED LOD Sigma",
      "COUNTD Sigma"
    ],
    "tags": [
      "tableau",
      "sigma",
      "formulas"
    ],
    "category": "Sigma how-to",
    "cover": "/images/blog/tableau-to-sigma-functions-cheat-sheet/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 7
  },
  {
    "slug": "tiktok-shop-settlement-vs-sale-price",
    "title": "Why does a TikTok Shop order settle for less than the sale price?",
    "description": "One real TikTok Shop order sold for 25.50 and settled for 12.25 while its commission field said 0.00. Here is the fee waterfall and how to check your own orders.",
    "seoTitle": "TikTok Shop settlement vs sale price: where the money goes",
    "date": "2026-11-04",
    "keywords": [
      "TikTok Shop settlement amount",
      "TikTok Shop fees breakdown",
      "TikTok Shop payout less than sale",
      "TikTok Shop affiliate commission reporting",
      "TikTok Shop order profitability"
    ],
    "tags": [
      "ecommerce",
      "analytics",
      "tiktok"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/tiktok-shop-settlement-vs-sale-price/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 6
  },
  {
    "slug": "what-can-you-do-with-business-numbers-you-trust",
    "title": "What can you do with business numbers you trust?",
    "description": "Trusted numbers let you make a specific call on spend, products, retention, or inventory, with an owner and a way to check the result. They don't prove cause.",
    "date": "2026-10-30",
    "keywords": [
      "data-driven ecommerce decisions",
      "actionable ecommerce analytics",
      "ecommerce decision making",
      "trusted business metrics"
    ],
    "tags": [
      "ecommerce",
      "analytics",
      "decision-making"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/what-can-you-do-with-business-numbers-you-trust/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 5
  },
  {
    "slug": "what-is-a-semantic-layer",
    "title": "What is a semantic layer? A plain-English guide",
    "description": "A semantic layer is a data dictionary with the metrics defined. It holds business definitions of metrics, dimensions, and joins that every tool reads from.",
    "date": "2026-11-04",
    "keywords": [
      "what is a semantic layer",
      "semantic layer vs data dictionary",
      "semantic layer vs metrics layer",
      "semantic layer tools",
      "semantic layer for AI"
    ],
    "tags": [
      "data-modeling",
      "snowflake",
      "bi"
    ],
    "category": "Guide",
    "cover": "/images/blog/what-is-a-semantic-layer/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 9
  },
  {
    "slug": "what-should-a-sigma-migration-assessment-include",
    "title": "What should a Sigma migration assessment include?",
    "description": "A useful Sigma migration assessment identifies assets, dependencies, data gaps, calculation risks, a representative pilot, and acceptance criteria.",
    "date": "2026-10-20",
    "updated": "2026-10-21",
    "keywords": [
      "Sigma migration assessment",
      "Tableau to Sigma migration checklist",
      "Power BI to Sigma migration checklist"
    ],
    "tags": [
      "sigma",
      "migration",
      "assessment"
    ],
    "category": "Migration assessment",
    "cover": "/images/blog/what-should-a-sigma-migration-assessment-include/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 5
  },
  {
    "slug": "where-do-amazon-seller-fees-live-in-the-sp-api",
    "title": "Amazon Seller Fees in SP-API: Which Source to Use",
    "description": "Amazon fees come from financial events, settlement reports, and FBA fee reports. Here is which source to use for payouts, SKU margin, storage, and reimbursements.",
    "date": "2026-09-02",
    "keywords": [
      "where do Amazon seller fees come from in the SP-API",
      "why don't Amazon fees match payout",
      "Amazon fees by SKU",
      "Amazon Finances API",
      "Amazon settlement report"
    ],
    "tags": [
      "amazon",
      "ecommerce",
      "apis"
    ],
    "category": "Amazon",
    "cover": "/images/blog/where-do-amazon-seller-fees-live-in-the-sp-api/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 7
  },
  {
    "slug": "which-dashboards-to-migrate-consolidate-or-retire",
    "title": "Which dashboards should you migrate, consolidate, or retire before moving to Sigma?",
    "description": "Prioritize Tableau and Power BI reports for a Sigma migration using business ownership, usage context, shared definitions, and downstream dependencies.",
    "seoTitle": "Sigma migration: which dashboards to move, merge, or retire",
    "date": "2026-10-20",
    "updated": "2026-10-21",
    "keywords": [
      "Sigma migration dashboard inventory",
      "Tableau dashboard retirement",
      "Power BI report consolidation"
    ],
    "tags": [
      "sigma",
      "migration",
      "assessment"
    ],
    "category": "Migration assessment",
    "cover": "/images/blog/which-dashboards-to-migrate-consolidate-or-retire/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 6
  },
  {
    "slug": "why-amazon-profit-changes-after-sale",
    "title": "Why Amazon profit changes after a sale: estimated vs actual fees",
    "description": "Amazon fee events can arrive after the order. Build a margin report that replaces estimates by fee component, exposes missing costs, and explains later changes.",
    "seoTitle": "Amazon profit after a sale: estimated vs actual fees",
    "date": "2026-10-31",
    "updated": "2026-11-04",
    "keywords": [
      "Amazon estimated vs actual fees",
      "Amazon profit reporting delay",
      "Amazon fee reconciliation",
      "ecommerce contribution margin"
    ],
    "tags": [
      "ecommerce",
      "analytics",
      "sigma"
    ],
    "category": "Guide",
    "cover": "/images/blog/why-amazon-profit-changes-after-sale/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 5
  },
  {
    "slug": "why-reliable-ecommerce-reporting-takes-time",
    "title": "Why does building reliable ecommerce reporting take time?",
    "description": "Connecting sources is often the quick part. The time goes to history, matching records, business rules, cost timing, validation, and getting people to use it.",
    "date": "2026-10-30",
    "updated": "2026-11-04",
    "keywords": [
      "ecommerce data warehouse implementation",
      "ecommerce dashboard implementation timeline",
      "why data projects take so long",
      "ecommerce reporting project"
    ],
    "tags": [
      "ecommerce",
      "data-modeling",
      "analytics"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/why-reliable-ecommerce-reporting-takes-time/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 6
  },
  {
    "slug": "why-shopify-finance-marketing-report-different-revenue",
    "title": "Why do Shopify, finance, and marketing report different revenue numbers?",
    "description": "Each team counts a different thing on a different date. An ecommerce semantic layer names each revenue metric, its grain, time zone, and owner.",
    "seoTitle": "Why Shopify, finance, and marketing report different revenue",
    "date": "2026-10-30",
    "keywords": [
      "why revenue numbers don't match Shopify",
      "ecommerce semantic layer",
      "semantic layer for ecommerce",
      "net revenue definition ecommerce",
      "Shopify vs finance revenue"
    ],
    "tags": [
      "ecommerce",
      "shopify",
      "data-modeling"
    ],
    "category": "Ecommerce",
    "cover": "/images/blog/why-shopify-finance-marketing-report-different-revenue/cover.png",
    "coverWidth": 1200,
    "coverHeight": 630,
    "readingMinutes": 7
  }
];
